const ButtonWrapper = ({ children, style = {}}) => {
    return (
        <div style={{ fontSize: '17rem', height: 60, marginBottom: 30, ...style }}>
            { children }
        </div>
    )
}

export default ButtonWrapper